import React from "react";

// index page sections
import Header from "./index/Header.jsx";
import Titles from "./index/Titles.jsx";
import GetStarted from "./index/GetStarted.jsx";
import Footer from "./index/Footer.jsx";

//import "assets/sass/laapp.scss";
import "assets/sass/demo.scss";

class Index extends React.Component {
  render() {
    return (
      <>
        <main ref='main'>
          <Header />
          <Titles />
          {/* <Palette /> */}

          {/* <Themeable /> */}
          {/* <Nwyneed /> */}
          <GetStarted />
        </main>

        <Footer />
      </>
    );
  }
}

export default Index;
